import React, { useState, useEffect } from "react";
import { Scheduler } from "@aldabil/react-scheduler";
import "./weekcalendar_1.css";
import { CustomViewerGeneral } from "../Admin_scheduler/Admin_scheduler";
import type {
  ProcessedEvent
} from "@aldabil/react-scheduler/types"
import "./weekcalendar_1.css"
import Api from "../../api"
import {
  showNotification,
  getFormattedCurDate,
  hasUserRole
} from "../../utils"

const TeacherScheduler = () => {
  const [events, setEvents] = useState([])

  const getEvents = async (filters: any) => {
    try {
      const data = await Api.Class.GetByFilters(filters)
      setEvents(data.map((e: any) => {
        const newEvent = {
          ...e,
          event_id: e.id || Math.random(),
          title: e.type,
          start: new Date(e.start_date),
          end: new Date(e.end_date)
        } as ProcessedEvent

        return newEvent
      }))
      showNotification('Éxito', 'Eventos obtenidos correctamente', 'success')
    } catch (error) {
      console.log(error)
      showNotification('Error', 'Eventos no obtenidos', 'danger')
    }
  }

  useEffect(() => {
    const registerParam = hasUserRole(['ROLE_STUDENT']) ? '&type=REGISTERED' : ''
    getEvents(`?start_date=${getFormattedCurDate(new Date())}${registerParam}`)
  }, [])
  
  return (
    <div className="week-calendar_container">

      <Scheduler
        events={events}
        month={{
          weekDays: [0, 1, 2, 3, 4, 5, 6],
          weekStartOn: 1,
          startHour: 6,
          endHour: 21,
        }}
        week={{
          weekDays: [0, 1, 2, 3, 4, 5, 6],
          weekStartOn: 1,
          startHour: 6,
          endHour: 21,
          step: 90,
        }}
        day={{
          startHour: 6,
          endHour: 21,
          step: 90,
        }}
        editable={false}
        deletable={false}
        //customEditor={(scheduler) => <CustomEditor scheduler={scheduler} getEvents={getEvents} />}
        customViewer={(event, close) => <CustomViewerGeneral event={event} close={close} />}
      />

    </div>
  )
}

export default TeacherScheduler;
